import { appCustomerGetters } from '@/store/items/appCustomer'
import { appUserGetters } from '@/store/items/appUser'
import { onboardingUserGetters } from '@/store/items/onboardingUser'

import { usersGetters } from '@/store/items/users'
import { selectedUserGetters } from '@/store/items/selectedUser'

import { customersGetters } from '@/store/items/customers'
import { selectedCustomerGetters } from '@/store/items/selectedCustomer'

import { proposalsGetters } from '@/store/items/proposals'
import { selectedProposalGetters } from '@/store/items/selectedProposal'

import { dealsGetters } from '@/store/items/deals'
import { selectedDealGetters } from '@/store/items/selectedDeal'

import { gamsetupsGetters } from '@/store/items/gamsetups'
import { selectedGamSetupGetters } from '@/store/items/selectedGamSetup'

import { optionscookielessGetters } from '@/store/items/optionscookieless'
import { selectedOptionsCookielessGetters } from '@/store/items/selectedOptionsCookieless'

import { storedRequestsGetters } from './items/storedRequests'
import { selectedStoredRequestGetters } from '@/store/items/selectedStoredRequest'

import { injectionsGetters } from './items/injections'
import { selectedInjectionGetters } from '@/store/items/selectedInjection'

import { sitesGetters } from '@/store/items/sites'
import { selectedSiteGetters } from './items/selectedSite'

const getters = {
  ...appCustomerGetters,
  ...appUserGetters,
  ...onboardingUserGetters,
  ...usersGetters,
  ...selectedUserGetters,
  ...customersGetters,
  ...selectedCustomerGetters,
  ...proposalsGetters,
  ...selectedProposalGetters,
  ...dealsGetters,
  ...selectedDealGetters,
  ...gamsetupsGetters,
  ...optionscookielessGetters,
  ...selectedOptionsCookielessGetters,
  ...selectedGamSetupGetters,
  ...sitesGetters,
  ...selectedSiteGetters,
  ...storedRequestsGetters,
  ...injectionsGetters,
  ...selectedStoredRequestGetters,
  ...selectedInjectionGetters,
  currencies: (state) => state.currencies,
  errors: (state) => {
    const r = state.errors
    state.errors = []
    return r
  }
}
export default getters
